export default (data, colIndex, order) => { 
    return data.sort((a, b) => { 
        /*
            //Date
            DT_AGENDA = 0
        */
        //Date
        if (colIndex === 0) { 
            var va = "";
            var vb = "";
            if (a.data[colIndex] !== "")
                va = new Date(moment(a.data[colIndex]+' 12:00:00',"DD/MM/YYYY hh:mm:ss").format("l"));
            if (b.data[colIndex] !== "")
                vb = new Date(moment(b.data[colIndex]+' 12:00:00',"DD/MM/YYYY hh:mm:ss").format("l"));
            return ((va < vb) || (va === "") ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
        //String ou Outros
        else { 
            return (a.data[colIndex] < b.data[colIndex] ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
    }); 
};